<template>
  <mdb-container fluid class="bv-example-row smswrapper">
    <mdb-row class="d-flex justify-content-center center reqsecondrow">
      <mdb-row class="subreqsecondrow">
        <mdb-btn @click.native="showModal = true" color="black">
          <span class="fontwhite">
            개인정보처리방침
          </span>
        </mdb-btn>
        <mdb-modal :show="showModal" @close="showModal = false" cascade class="text-left">
        <mdb-modal-header class="mt-3 mb-4 mx-5">
          <h4 class="title">
            <fa class="fas fa-pencil-alt" />
            <span class="fontblack">
              개인정보 수집 및 이용 동의
            </span>
          </h4>
        </mdb-modal-header>
        <mdb-modal-body class="black-text">
          개인정보 활용 정책<br/>
          1. 개인정보의 수집목적 및 이용<br/>
          &nbsp;&nbsp;  가. 다음과 같은 목적을 위하여 고객님의<br/>
          &nbsp;&nbsp;  개인정보를 수집 및 이용하고 있습니다.<br/>
          &nbsp;&nbsp;&nbsp;&nbsp;- 자동차리스 견적상담 및 관련 서비스 제공<br/>
          <br/>
          2. 수집하는 개인정보 항목<br/>
          &nbsp;&nbsp;   가. 개인정보 항목 - 이름, 핸드폰번호,관심차종<br/>
          &nbsp;&nbsp; 나. 수집방법 - 동의 체크박스에 클릭할 경우,<br/>
          &nbsp;&nbsp;   개인정보수집에 동의한 것으로 간주합니다<br/>
          <br/>
          3. 개인정보의 보유 및 이용기간<br/>
          &nbsp;&nbsp;   가. 이용자가 제공하는 개인정보는 최종 상담일로부터<br/>
          &nbsp;&nbsp;   1년후 더 이상의 상담이 이뤄지지 않으면 파기합니다.<br/>
          &nbsp;&nbsp;   나. 이용자가 개인정보의 파기를 요청하는경우<br/>
          &nbsp;&nbsp;   해당 이용자의 개인정보를 파기합니다.<br/>
        </mdb-modal-body>
        <mdb-modal-footer>
            <mdb-btn class="btnfooter" @click.native="showModal = false" color="yellow">닫기</mdb-btn>
        </mdb-modal-footer>
        </mdb-modal>
      </mdb-row>
    </mdb-row>
  </mdb-container>
</template>

<script>

export default {
  name: 'FormsPage',
  data() {
    return {
      showModal: false,
    };
  },
};
</script>

<style scoped>
.smswrapper {
  background-color: #212121;
  max-width: 100%;
  max-height: 800px;
  margin: 0px 0px;
  padding: 0px 0px;
}

@media (max-width: 500px){
  .smswrapper {
    background-color: #212121;
    max-width: 100%;
    height: auto;
    margin: 0px 0px;
    padding: 0px 0px;
  }
}

.pb-1, .py-1 {
    padding-bottom: 10px !important;
}

.ml-5, .mx-5 {
    margin-left: 8px !important;
}

.mr-5, .mx-5 {
    margin-right: 10px !important;
}

.mb-4, .my-4 {
    margin-bottom: 10px !important;
}

.mt-3, .my-3 {
    margin-top: 10px !important;
}

.reqsecondrow {
  margin: 0px 0px !important;
  max-height: 100% !important;
  background-color: #212121;
}

.subreqsecondrow {
  margin: 0px 0px !important;
  max-height: 100% !important;
  align-items: center;
  margin: 0px 0px !important;
  max-height: 380px !important;
  background-color: black;
  width: 100%;
}

.btn-info {
  color: black;
  background-color: #ffba00 !important;
}

.btn-info :hover {
  color: white;
  background-color: #ffba00 !important;
}

.btn-yellow:hover {
    color:cornsilk;
    background-color: #ffba00;
}

.btn-yellow {
    color: cornsilk;
    background-color: #ffba00;
}

.btn {
  margin: 1% auto;
  font-weight: 550;
  text-transform: uppercase;
  word-wrap: break-word;
  white-space: normal;
  cursor: pointer;
  border: 0;
  border-radius: .125rem;
  padding: .94rem 2.24rem;
  font-size: 14px;
  color: black;
}

.btn-yellow:hover {
    color: #fff;
    background-color: #fbc846;
}

.fa, .fas {
  font-weight: 550;
}

.fa, .far, .fas {
  font-family: "Font Awesome 5 Free";
}

.fa, .fab, .fad, .fal, .far, .fas {
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  display: inline-block;
  font-style: normal;
  font-variant: normal;
  text-rendering: auto;
}

.pl-1, .px-1 {
  padding-left: 0px !important;
}

.fontwhite{
  color: white;
}

.fontblack{
  color: black;
}

.btnfooter {
  margin-left: 0;
  margin-right: 37%;
}
</style>
